import { useState, useEffect, useCallback } from 'react'

interface AuthState {
  isAuthenticated: boolean
  isLoading: boolean
  token: string | null
}

export function useAuth() {
  const [state, setState] = useState<AuthState>({
    isAuthenticated: false,
    isLoading: true,
    token: null,
  })

  useEffect(() => {
    const token = localStorage.getItem('lex_access_token')
    if (token) {
      setState({ isAuthenticated: true, isLoading: false, token })
    } else {
      setState({ isAuthenticated: false, isLoading: false, token: null })
    }
  }, [])

  const login = useCallback(async (email: string, password: string) => {
    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      })

      if (!response.ok) throw new Error('Login failed')

      const data = await response.json()
      localStorage.setItem('lex_access_token', data.accessToken)
      localStorage.setItem('lex_refresh_token', data.refreshToken)
      setState({ isAuthenticated: true, isLoading: false, token: data.accessToken })
    } catch (error) {
      setState({ isAuthenticated: false, isLoading: false, token: null })
      throw error
    }
  }, [])

  const logout = useCallback(() => {
    localStorage.removeItem('lex_access_token')
    localStorage.removeItem('lex_refresh_token')
    setState({ isAuthenticated: false, isLoading: false, token: null })
  }, [])

  return { ...state, login, logout }
}